export const formFieldErrorFormatter: { [key: string]: CallableFunction } = {
  email: () => 'Email not valid',
  required: () => 'Required',
  minlength: (value: { requiredLength: number; actualLength: number }) => {
    return `${value.actualLength}/${value.requiredLength} required characters`;
  },
};
